import { Injectable } from '@angular/core';
import {from, Observable, of, throwError} from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import {classToPlain, plainToClass} from 'class-transformer';
import {db} from "../../dexie/db";

import { SOPutBacklog } from './so-put-backlog';
import { SOGetBacklog } from './so-get-backlog';
import { SOPostBacklog } from './so-post-backlog';
import { SODeleteBacklog } from './so-delete-backlog';
import {SORespBacklog} from './so-resp-backlog';
import {SOPluralBacklog} from './so-plural-backlog';

import {MMEntityService} from 'lionheartland';
import {EntityCoreProtocol} from 'lionheartland';
import {MMEntityServiceBase} from 'lionheartland';
import {HttpHeaders} from "@angular/common/http";

export class EOBacklogService extends MMEntityServiceBase implements MMEntityService {

  constructor(
    public entityCore: EntityCoreProtocol,
  ) {
    super('backlog', entityCore);
  }

  /** GET Backlog by id. Will 404 if id not found */
  get(request: SOGetBacklog): Observable<SOPluralBacklog> {
    return this.httpClient.get<SOPluralBacklog>(this.makeGetUri(request), this.httpOptions).pipe(
      map(resp => plainToClass(SOPluralBacklog, resp)),
      tap(async (response: SOPluralBacklog) => {
        this.log(`fetched Backlog`);
        // After a successful server response, update IndexedDB
        const activities = response.toBacklogs(); // Convert your response to an array of Backlog instances
        const promises = activities.map(backlog => db.backlogs.put(backlog));
        await Promise.all(promises); // Wait for all the IndexedDB update operations to complete
      }),
      catchError(this.handleError<SOPluralBacklog>(`get Backlog`))
    );
  }

    /** GETCACHE for initial display with CacheQueryProtocol */
    getCache(cacheQuery: any): Observable<SOPluralBacklog> {
        console.log("GETCACHE", cacheQuery);

        if (cacheQuery.filterKey === 'backlog' && cacheQuery.filterValue && cacheQuery.filterOrganization)
        {
            console.log("cache filtering based on parent and organization")
            return from(db.backlogs.where('parentUid').equals(cacheQuery.filterValue).and(item => item.organizationUid === cacheQuery.filterOrganization.uid).toArray()).pipe(
                map(backlogsArray => this.processBacklogs(backlogsArray)),
                catchError(error => this.handleQueryError(error))
            );
        }
        else if (cacheQuery.filterKey + "s" == "works" && cacheQuery.filterValue && cacheQuery.filterOrganization)
        {
            console.log("cache filtering based on relationship and organization")
            return from(db.backlogs.where('worksUid').equals(cacheQuery.filterValue).and(item => item.organizationUid === cacheQuery.filterOrganization.uid).toArray()).pipe(
                map(backlogsArray => this.processBacklogs(backlogsArray)),
                catchError(error => this.handleQueryError(error))
            );
        }        else if (cacheQuery.filterKey + "s" == "project" && cacheQuery.filterValue && cacheQuery.filterOrganization)
        {
            console.log("cache filtering based on relationship and organization")
            return from(db.backlogs.where('projectUid').equals(cacheQuery.filterValue).and(item => item.organizationUid === cacheQuery.filterOrganization.uid).toArray()).pipe(
                map(backlogsArray => this.processBacklogs(backlogsArray)),
                catchError(error => this.handleQueryError(error))
            );
        }        else if (cacheQuery.filterKey + "s" == "organization" && cacheQuery.filterValue && cacheQuery.filterOrganization)
        {
            console.log("cache filtering based on relationship and organization")
            return from(db.backlogs.where('organizationUid').equals(cacheQuery.filterValue).and(item => item.organizationUid === cacheQuery.filterOrganization.uid).toArray()).pipe(
                map(backlogsArray => this.processBacklogs(backlogsArray)),
                catchError(error => this.handleQueryError(error))
            );
        }        else if (cacheQuery.filterOrganization || cacheQuery.organization.uid)
        {
            console.log("tripped organization for cache query")
            if ( cacheQuery?.filterOrganization != null )
            {
                console.log("cache filtering based on organization CQP", cacheQuery)
                return from(db.backlogs.where('organizationUid').equals(cacheQuery.filterOrganization).toArray()).pipe(
                    map(backlogsArray => this.processBacklogs(backlogsArray)),
                    catchError(error => this.handleQueryError(error))
                );
            }
            else if ( cacheQuery?.organization?.uid != null )
            {
                console.log("UID:", cacheQuery.organization.uid)
                console.log("cache filtering based on organization SOGet")
                return from(db.backlogs.where('organizationUid').equals(cacheQuery.organization.uid).toArray()).pipe(
                    map(backlogsArray => this.processBacklogs(backlogsArray)),
                    catchError(error => this.handleQueryError(error))
                );
            }
            else
            {
                console.log("null organization")
            }
        }
        else
        {
            console.log("cache no filter")
            return from(db.backlogs.toArray()).pipe(
                map((backlogsArray) => {
                    // Convert the array of plain objects to an array of SORespBacklog instances
                    const sorBacklogs = backlogsArray.map(req => plainToClass(SORespBacklog, req));
                    // Create and return a new instance of SOPluralBacklog
                    const pluralBacklog = new SOPluralBacklog();
                    pluralBacklog.objects = sorBacklogs;
                    pluralBacklog.nextOffset = null; // Assuming there is no pagination in cache
                    return pluralBacklog;
                }),
                catchError(error => this.handleQueryError(error))
            );
        }
    }

    private processBacklogs(backlogsArray) {
        const sorBacklogs = backlogsArray.map(req => plainToClass(SORespBacklog, req));
        const pluralBacklog = new SOPluralBacklog();
        pluralBacklog.objects = sorBacklogs;
        pluralBacklog.nextOffset = null;
        return pluralBacklog;
    }

    private handleQueryError(error) {
        console.error('Error in query:', error);
        return throwError(error); // Return an observable error
    }

post(request: SOPostBacklog): Observable<SORespBacklog> {
  return this.httpClient.post<SORespBacklog>(this.coreUrl + this.route, request, this.httpOptions).pipe(
    map(resp => plainToClass(SORespBacklog, resp)),

    tap(async (response: SORespBacklog) => {
      this.log(`added Backlog w/ id=${response.uid}`);
      // After a successful server response, update IndexedDB
      console.log("here", response);
      console.log("here request", request);
      await db.backlogs.add(response.toBacklog());
    }),
    catchError(this.handleError<SORespBacklog>('Backlog post'))
  );
}


  put(request: SOPutBacklog): Observable<SORespBacklog> {
    const uid = request.uid;
    const uri = `${this.coreUrl}${this.route}/${uid}`;
    return this.httpClient.put<SORespBacklog>(uri, request, this.httpOptions).pipe(
      map(resp => plainToClass(SORespBacklog, resp)),
      tap(async (response: SORespBacklog) => {
        this.log(`edited Backlog w/ uid=${uid}`);
        // After a successful server response, update IndexedDB
        await db.backlogs.put(response.toBacklog());
      }),
      catchError(this.handleError<SORespBacklog>('Backlog put'))
    );
  }


  delete(request: SODeleteBacklog): Observable<SORespBacklog> {
    return this.httpClient.delete<SORespBacklog>(this.makeDeleteUri(request), this.httpOptions).pipe(
      tap(async _ => {
        this.log(`deleted Backlog uid=${request.uid}`);
        // After a successful server response, update IndexedDB
        await db.backlogs.delete(request.uid);
      }),
      catchError(this.handleError<SORespBacklog>('Backlog delete'))
    );
  }


}
